import React, { useEffect, useState } from 'react';
import { ModalWrapper, themeConfig } from './LoginPromptModal.styles';

const LoginPromptModal = ({ 
    isOpen, 
    messageCount, 
    messageLimit,
    onSignIn, 
    onCreateAccount, 
    onClose 
}) => {
    const [themeMode, setThemeMode] = useState('dark');

    useEffect(() => {
        // Leer tema del localStorage
        const savedTheme = localStorage.getItem('themeMode') || 'dark';
        setThemeMode(savedTheme);

        // Listener para detectar cambios de tema en tiempo real (opcional)
        const handleStorageChange = (e) => {
            if (e.key === 'themeMode') {
                setThemeMode(e.newValue || 'dark');
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    if (!isOpen) return null;

    return (
        <ModalWrapper theme={themeConfig[themeMode]}>
            <div className="login-modal-overlay" onClick={onClose} />
            <div className="login-modal">
                {/* Header con SVG Lock Icon */}
                <div className="login-modal-header">
                    <svg 
                        className="login-modal-icon" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path 
                            d="M17 10H18C19.1046 10 20 10.8954 20 12V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V12C4 10.8954 4.89543 10 6 10H7M17 10V7C17 4.79086 15.2091 3 13 3H11C8.79086 3 7 4.79086 7 7V10M17 10H7" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round"
                        />
                        <circle 
                            cx="12" 
                            cy="15" 
                            r="2" 
                            fill="currentColor"
                        />
                    </svg>
                    <h2>Message Limit Reached</h2>
                </div>

                {/* Body */}
                <div className="login-modal-body">
                    <p className="login-modal-message">
                        You've used <strong>{messageCount}/{messageLimit}</strong> free messages.
                        <br />
                        Sign in to continue chatting!
                    </p>

                    {/* Benefits con SVG Checkmarks */}
                    <div className="login-modal-benefits">
                        <div className="benefit-item">
                            <svg 
                                className="benefit-icon" 
                                viewBox="0 0 20 20" 
                                fill="none" 
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="10" cy="10" r="9" fill="currentColor" opacity="0.2"/>
                                <path 
                                    d="M6 10L9 13L14 7" 
                                    stroke="currentColor" 
                                    strokeWidth="2" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span>Unlimited messages</span>
                        </div>
                        <div className="benefit-item">
                            <svg 
                                className="benefit-icon" 
                                viewBox="0 0 20 20" 
                                fill="none" 
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="10" cy="10" r="9" fill="currentColor" opacity="0.2"/>
                                <path 
                                    d="M6 10L9 13L14 7" 
                                    stroke="currentColor" 
                                    strokeWidth="2" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span>Save conversations</span>
                        </div>
                        <div className="benefit-item">
                            <svg 
                                className="benefit-icon" 
                                viewBox="0 0 20 20" 
                                fill="none" 
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="10" cy="10" r="9" fill="currentColor" opacity="0.2"/>
                                <path 
                                    d="M6 10L9 13L14 7" 
                                    stroke="currentColor" 
                                    strokeWidth="2" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span>Create projects</span>
                        </div>
                        <div className="benefit-item">
                            <svg 
                                className="benefit-icon" 
                                viewBox="0 0 20 20" 
                                fill="none" 
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="10" cy="10" r="9" fill="currentColor" opacity="0.2"/>
                                <path 
                                    d="M6 10L9 13L14 7" 
                                    stroke="currentColor" 
                                    strokeWidth="2" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span>Advanced tools</span>
                        </div>
                    </div>
                </div>

                {/* Actions */}
                <div className="login-modal-actions">
                    <button 
                        className="login-modal-btn btn-primary" 
                        onClick={onSignIn}
                    >
                        Sign In
                    </button>
                    <button 
                        className="login-modal-btn btn-secondary" 
                        onClick={onCreateAccount}
                    >
                        Create Account
                    </button>
                    <button 
                        className="login-modal-btn btn-ghost" 
                        onClick={onClose}
                    >
                        Maybe Later
                    </button>
                </div>
            </div>
        </ModalWrapper>
    );
};

export default LoginPromptModal;